import { render, staticRenderFns } from "./followHint.vue?vue&type=template&id=3b9e3bfa&scoped=true&"
import script from "./followHint.vue?vue&type=script&lang=js&"
export * from "./followHint.vue?vue&type=script&lang=js&"
import style0 from "./followHint.vue?vue&type=style&index=0&id=3b9e3bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e3bfa",
  null
  
)

export default component.exports